<template>
  <div>
    <div class="draggable-wrapper" ref="draggableWrapper">
      <div class="draggable-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HDraggable',

  computed: {
    draggableWrapper() {
      return this.$refs.draggableWrapper
    },
  },

  methods: {
    initDraggable() {
      const container = this.$refs.draggableWrapper

      let isDown = false
      let scrollLeft
      let startX

      container.addEventListener("mousedown", (event) => {
        isDown = true
        startX = event.pageX - container.offsetLeft
        scrollLeft = container.scrollLeft
      })

      container.addEventListener("mouseleave", () => {
        isDown = false
      })

      container.addEventListener("mouseup", () => {
        isDown = false
      })

      container.addEventListener("mousemove", (event) => {
        if (!isDown) return

        if (!this.isTextSelectable(event.target)) {
          event.preventDefault()

          const x = event.pageX - container.offsetLeft
          const walk = x - startX

          container.scrollLeft = scrollLeft - walk
        }
      })
    },

    isTextSelectable(element) {
      const selectableElements = ['input', 'textarea', 'select', 'button', 'span']

      if (selectableElements.includes(element.tagName.toLowerCase())) {
        return true
      }

      if (window.getSelection().toString().length > 0) {
        return true
      }

      return false
    }
  },

  mounted() {
    this.initDraggable()
  },
}
</script>

<style>
.draggable-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.draggable-content {
  display: inline-block;
  min-width: calc(100dvw - 156px);
}
</style>
